import { renderInDocument } from '@spotahome/soyuz/client';

import InstitutionContainer from './main';

renderInDocument(InstitutionContainer);
